import { Grid } from "@material-ui/core";
import Staff from "../../actions/staff";
import Controls from "../controls/Controls";
import { Form, useForm } from "../customHelpers/useForm";
const initialFValues = {
  newPassword: "",
  oldPassword: "",
};
const StaffChangePassword = ({
  NotifyMessage,
  setOpenPopup,
}) => {
  const { staffChangePassword} = Staff();
  const validate = (fieldValues = values) => {
    const temp = { ...errors };
    if ("newPassword" in fieldValues)
      temp.newPassword = fieldValues.newPassword.length != 0 ? "" : "This field is required.";
    if ("oldPassword" in fieldValues)
        temp.oldPassword = fieldValues.oldPassword.length != 0 ? "" : "This field is required.";
  

    setErrors({
      ...temp,
    });
    if (fieldValues == values) return Object.values(temp).every((x) => x == "");
  };

  const { values, errors, setValues, handleInputChange, setErrors, resetForm } =
    useForm(initialFValues, true, validate);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      setValues({ ...values, submitting: true });
           staffChangePassword(values).then((data) => {
          if (data.err) {
            setValues({ ...values, submitting: false });
            NotifyMessage({
              message: data.err,
              type: "error",
            });
          } else if (data.staff) {
            NotifyMessage({
              message: "Password successfully Changed",
              type: "success",
            });
            setOpenPopup(false);
            resetForm();
          }
        });
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Grid container>
        <Grid item xs={6}>
          <Controls.Input
            name="oldPassword"
            label="Old Password"
            value={values.oldPassword}
            onChange={handleInputChange}
            error={errors.oldPassword}
          />
        </Grid>
        <Grid item xs={6}>
          <Controls.Input
            name="newPassword"
            label="NeW Password"
            value={values.newPassword}
            onChange={handleInputChange}
            error={errors.newPassword}
          />
        </Grid>
        <Grid item xs={6}/>
        <Grid item xs={6}/>
        <Grid item xs>
          <div>
            <Controls.Button
              disabled={values.submitting ? true : false}
              text={values.submitting ? "Sending..." : "Done"}
              variant="contained"
              className="Button"
              type="submit"
            />
            <Controls.Button
              text={"Cancel"}
              variant="contained"
              className="Button"
              onClick={() => {
                setOpenPopup(false);
              }}
            />
          </div>
        </Grid>
      </Grid>
    </Form>
  );
};

export default StaffChangePassword;
